import { createFileRoute, Outlet } from "@tanstack/react-router";
import { BottomNav } from "@/components/BottomNav";

export const Route = createFileRoute("/retos")({
  component: RetosLayout,
});

function RetosLayout() {
  return (
    <>
      <Outlet />
      <BottomNav />
    </>
  );
}
